import React from 'react';
import { motion } from 'framer-motion';
import { Zap, ShieldCheck, CreditCard, Star } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-2 pb-10 px-4 md:pt-4 md:pb-14 max-w-5xl mx-auto text-center overflow-hidden" data-id="element-91">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} data-id="element-92">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-red-500/40 bg-red-500/10 text-red-500 text-xs font-bold tracking-widest uppercase mb-6" data-id="element-93">
          Para vos, NUTRICIONISTA⚖️
        </div>

        <h1 className="md:text-5xl lg:text-6xl mb-6 text-cream max-w-4xl mx-auto font-[900] font-[Georgia,_serif] text-[18px]" data-id="element-94">
          Tené tu consulta infantil en minutos con materiales listos para usar
        </h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="mb-8 flex justify-center" data-id="element-95">
          <img src="https://cdn.magicpatterns.com/uploads/xeg8juBHb8trTfqAzjG5Ej/b373bf6b-a5d9-4e03-b9ce-f6107e3ea755_(1).png" alt="MegaPack Nutri Infantil Lista — vista previa de los 6 módulos, plato saludable en tablet y ejemplo de comida completa en mobile" className="w-full max-w-3xl h-auto drop-shadow-[0_20px_50px_rgba(216,195,165,0.25)]" data-id="element-96" />
        </motion.div>

        <p className="text-lg md:text-xl text-cream/90 mb-6 max-w-3xl mx-auto font-medium" data-id="element-97">
          Ordená tus casos, intervení con más claridad y enseñale al niño qué
          comer con materiales listos para usar, imprimir y aplicar.
        </p>

        <div className="flex flex-col items-center gap-3 mb-8" data-id="element-98">
          <div className="flex items-center gap-1 text-terracotta" data-id="element-99">
            {[...Array(5)].map((_, i) => <Star key={i} size={18} className="fill-current" data-id="element-100" />)}
          </div>
          <p className="text-sm text-cream/80 font-medium" data-id="element-101">
            4.9/5 (+850 reseñas verificadas)
          </p>
          <div className="inline-flex items-center gap-2 bg-terracotta/10 border border-terracotta/20 text-terracotta px-4 py-1.5 rounded-full text-sm font-medium mt-2" data-id="element-102">
            <span data-id="element-103">🔥</span> 62 nutricionistas eligieron este pack hoy
          </div>
        </div>

        <motion.a href="#oferta-completa" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="inline-flex items-center justify-center gap-2 bg-terracotta hover:bg-terracottaDark text-white font-bold text-lg md:text-xl py-4 px-8 rounded-xl shadow-lg shadow-terracotta/20 transition-all w-full md:w-auto" data-id="element-104">
          <span data-id="element-105">🚀</span> ¡SÍ! QUIERO ORDENAR MI CONSULTA
        </motion.a>

        <div className="flex flex-wrap justify-center gap-4 mt-6" data-id="element-106">
          <div className="flex items-center gap-1.5 text-cream/60 text-sm font-medium" data-id="element-107">
            <Zap size={16} className="text-sand" data-id="element-108" />
            Acceso inmediato
          </div>
          <div className="flex items-center gap-1.5 text-cream/60 text-sm font-medium" data-id="element-109">
            <ShieldCheck size={16} className="text-sand" data-id="element-110" />
            Garantía 7 días
          </div>
          <div className="flex items-center gap-1.5 text-cream/60 text-sm font-medium" data-id="element-111">
            <CreditCard size={16} className="text-sand" data-id="element-112" />
            Pago único
          </div>
        </div>
      </motion.div>
    </section>;
}